module.exports = __webpack_public_path__ + "static/GorditaBold-Italic-248aba2b64ef00f1b2f774ea3442b482.otf";